//BELOW you can find the HTML structure required to run this Helper effectively
// import FavButton from '../../UM-Base/components/FavButton';
import { initFavButton } from '../lib/FavButtonsHelper';
import { initAddToTripCardBtnListeners } from '../lib/AddToTripCardBtnHelper';

initAddToTripCardBtnListeners();
// var favButtons = new FavButton();

// Set up an observer on the body to detect when target divs are added
const bodyObserver = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(node => {

        if (node.nodeType === Node.ELEMENT_NODE) {
          const targetDivs = node.matches('.dynamicDiv') ? [node] : [...node.querySelectorAll('.dynamicDiv')];
          targetDivs.forEach(targetDiv => {
            let getExperimentStatus = targetDiv.querySelector(".placeValue")?.textContent;
            if (getExperimentStatus) {
              // Call your function to handle the div content change
              handleDivContentChange(getExperimentStatus, "apiParam", targetDiv);
              // Initialize your favorite button or any other logic
              initFavButton();
            } else {
              console.log("No OWE set for the dynamicDiv");
            }
      });
    }
    });      
    }
  });
});

// Observe the entire body for the addition of new elements
bodyObserver.observe(document.body, { childList: true, subtree: true });

// Storing the body observer, if needed
if (this && this.observers) {
  this.observers = this.observers || [];
  this.observers.push(bodyObserver);
}

function handleDivContentChange(newValue, apiParams, div) {
  // Implement your logic here that should happen when the div content changes
  // You can use the apiParams to tailor the API call or other actions
  console.log('Handling div content change with API parameters:', newValue, apiParams);
  // Retrieve the immediate value of the .dynamicProductsList within the div

  var productIdsElement = div.querySelector(".dynamicProductsList");
  
  var productIds = "";
  if (productIdsElement) {
    productIds = productIdsElement.textContent;
  } else {
    console.error("dynamicProductsList element not found in the target div");
  }

  if (productIds) {
    fetchProducts(productIds, productIdsElement);
  }
}

function buildProductListHTML(products) {
  const ul = document.createElement('ul');
  ul.className = 'related-content__list';

  products.forEach(product => {
    const li = document.createElement('li');
    const productId = product.id;
    const productImage = product.imageUrls ? product.imageUrls[0] : "";
    const productUrl = removeHostFromUrl(product.url);
    const region = product.region;
    const productName = product.title;
    const productCategory = product.category;
    li.className = 'search-grid__list-item';
    li.innerHTML = `
        <div class="product-card__wrapper">
          <!-- Populate with product details -->
          <div class="product-card">
            <div class="product-card__container">
                <article class="product-card__area" productid="${productId}">
                <a href="${productUrl}" class="product-card__primary">
                    <div class="product-card__image bgimage lazied" data-src="${productImage}.jpeg?w=576&amp;rot=360&amp;width=576&amp;mode=stretch" data-holdersrc="/media/xm5hoilc/loading-atdw-image-light.png" style="background-image: url(&quot;${productImage}.jpeg?w=576&amp;rot=360&amp;width=576&amp;mode=stretch&quot;), url(&quot;/media/xm5hoilc/loading-atdw-image-light.png&quot;);">
                            <div class="product-card__image-info">
                                <div class="product-card__image-info-section">
                                    <div class="product-card__category--hover">${productCategory}</div>
                                </div>
                            </div>
                    </div>

                    <div class="product-card__content">
                        <div class="product-card__header">
                                <div class="product-card__category">${productCategory}</div>
                        </div>
                        <div class="product-card__region">
                                <span class="product-card__location">${region}</span>
                        </div>

                        <header class="product-card__main">
                            <h4 class="product-card__title" data-score="0">
                                ${productName}
                            </h4>
                        </header>
                        <footer class="product-card__footer">
                        </footer>
                            <div class="product-card__listing-placeholder"></div>
                    </div>
                  </a>

                  <div class="product-card__more">
                    <div class="product-card__fav">
                        <button class="product-card__fav-btn" title="favourite"><i class="far fa-heart"></i></button>
                      </div>
                    <button class="product-card__morelink js-addtotrip-btn" productid="${productId}" productname="${productName}" producttype="${productCategory}" productlocation="${region}">
                        <i class="far fa-map-marker-plus"></i>
                        Add to my trip
                    </button>
                  </div>
                </article>
            </div>
          </div>
        </div>
      `;
    // Populate the innerHTML of li with actual product details from the product object
    ul.appendChild(li);
  });

  return ul;
}

function removeHostFromUrl(url) {
  // Parse the URL
  const parsedUrl = new URL(url);

  // Construct the URL without the host
  return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
}

function appendProductList(productList, productIdsElement) {

  // Need to pass the component container which would be dynamicDiv
  const relatedContentList = document.querySelector('.related-content__list');
  let sectionTitle = "";
  let sectionSubTitle = "";

  // Check if the element exists
  if (productIdsElement) {

    sectionTitle = productIdsElement.dataset.title;
    sectionSubTitle = productIdsElement.dataset.subtitle;

    // Creating the wrapper divs
    const wrapperDiv = document.createElement('div');
    wrapperDiv.className = 'related-content__wrapper related-content__wrapper--product';

    const relatedContentDiv = document.createElement('div');
    relatedContentDiv.className = 'related-content related-content--product';

    const containerDiv = document.createElement('div');
    containerDiv.className = 'related-content__container container pb-4';

    const outerContainer = document.createElement('div');
    outerContainer.className = 'container'; // Adding the new outer container div

    relatedContentList.innerHTML = ''; // Clear existing content if needed
    const header = `
        <div class="container">
            <div class="block-title container pt-2 pb-2">
                    <div class="hr  px-3">
                        <hr class="hr__line">
                    </div>
                    <h2 class="title title--separator">
                            <span class="title__subtitle">${sectionSubTitle}</span>
                            <strong class="title__title">${sectionTitle}</strong>
                    </h2>
            </div>
        </div>
      `;
    relatedContentList.innerHTML += header;
  
    containerDiv.appendChild(productList);
    // Nesting the elements
    relatedContentDiv.appendChild(containerDiv);
    wrapperDiv.appendChild(relatedContentDiv);
    relatedContentList.appendChild(wrapperDiv); // Appending the wrapper to the relatedContentList
    window.satc.runFlickityOnRelatedContentProduct();
    window.satc.initAddToTripCardBtnListeners();

  } else {
    console.log("related-content__list element not found");
  }
}

function fetchProducts(productIds, productIdsElement) {
  const substringsToCheck = [",", ";"];

  const url = `/umbraco/api/product/get?id=${productIds}`;
  if (substringsToCheck.every(substring => productIds.includes(substring))) {
    console.log("The products ids are are not well formed for the ABExperiment");
    return false;
  }

  fetch(url)
    .then(response => {

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      // Process or return data as needed
      const productList = data;
      const ids = productIds.split('-').map(id => id.trim());
      const products = productList.filter(product => ids.includes(product.id))
      
      appendProductList(buildProductListHTML(products), productIdsElement);
      initFavButton();
      return data;
    })
    .catch(error => {
      console.error('Error fetching Product data: ', error);
    });

}
/*
DO NOT DELETE THE CODES BELOW
//The HTML code and structure you need to run to make it work
// We can provide options for content team to choose if the HTML should be added before or after the target class
// The default is after the target class

// HTML string
 var targetClass = `${extension.targetClass}`;
    var targetSelector = `${extension.targetClassSelector}`;
		var title = `${extension.title}`;
    var subTitle = `${extension.subTitle}`;
    var productList = `${extension.productList}`;
var htmlString = `
    <div class="dynamicDiv hideme">
        This is used for ABTesting
        <div class="placeValue">complete</div>
        <div style="display:none;" data-product="true" class="dynamicProductsList" data-title="${title}" data-subTitle="${subTitle}">
					${productList}
        </div>
    </div>
    <div class="related-content__list"></div>`;
// Create a temporary container for the HTML string
var tempContainer = document.createElement('div');
tempContainer.innerHTML = htmlString;

// Find the target element
var target = document.querySelector(targetSelector);

// Check if the target element exists
if (target) {
    // Move each child element from the temporary container to after the target element
    while (tempContainer.children.length > 0) {
        // Using insertAdjacentElement to place elements after the target
        target.insertAdjacentElement('afterend', tempContainer.children[0]);
    }
} else {
    console.error('Target element with class ' + targetSelector + ' not found');
}

*/
